// src/features/dashboard/pages/NotFound.tsx

import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaHome,
  FaSearch,
} from 'react-icons/fa';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="
        relative
        flex
        min-h-screen
        items-center
        justify-center
        overflow-hidden
        bg-gradient-to-br
        from-slate-50
        via-blue-50
        to-indigo-50
      "
    >
      {/* Animated Background */}

      <div
        className="
          absolute
          left-10
          top-10
          h-72
          w-72
          animate-pulse
          rounded-full
          bg-blue-300/20
          blur-3xl
        "
      />

      <div
        className="
          absolute
          right-20
          top-32
          h-96
          w-96
          animate-pulse
          rounded-full
          bg-indigo-300/20
          blur-3xl
        "
      />

      <div
        className="
          absolute
          bottom-10
          left-1/3
          h-80
          w-80
          animate-pulse
          rounded-full
          bg-cyan-300/20
          blur-3xl
        "
      />

      {/* Card */}

      <div
        className="
          relative
          z-10
          w-full
          max-w-3xl
          rounded-[32px]
          border
          border-white/50
          bg-white/80
          p-12
          text-center
          shadow-[0_20px_60px_rgba(0,0,0,0.12)]
          backdrop-blur-xl
        "
      >
        {/* Icon */}

        <div
          className="
            mx-auto
            flex
            h-24
            w-24
            items-center
            justify-center
            rounded-full
            bg-[#EDF4FF]
          "
        >
          <FaSearch
            size={32}
            className="text-[#002B5B]"
          />
        </div>

        {/* 404 */}

        <h1
          className="
            mt-8
            animate-pulse
            text-[120px]
            font-black
            leading-none
            text-[#002B5B]
          "
        >
          404
        </h1>

        {/* Heading */}

        <h2
          className="
            mt-2
            text-4xl
            font-bold
            text-slate-800
          "
        >
          Page Not Found
        </h2>

        {/* Description */}

        <p
          className="
            mx-auto
            mt-5
            max-w-xl
            text-base
            leading-7
            text-slate-500
          "
        >
          The page you are looking for may have
          been moved, deleted, or never existed.
          Please return to the dashboard and
          continue your productivity journey.
        </p>

        {/* Buttons */}

        <div
          className="
            mt-10
            flex
            flex-col
            justify-center
            gap-4
            sm:flex-row
          "
        >
          <button
            onClick={() => navigate('/')}
            className="
              flex
              items-center
              justify-center
              gap-2
              rounded-xl
              bg-[#002B5B]
              px-8
              py-3
              font-semibold
              text-white
              transition-all
              duration-300
              hover:-translate-y-1
              hover:shadow-lg
            "
          >
            <FaHome />

            Home
          </button>

          <button
            onClick={() =>
              navigate('/rm-dashboard')
            }
            className="
              flex
              items-center
              justify-center
              gap-2
              rounded-xl
              border
              border-slate-300
              bg-white
              px-8
              py-3
              font-semibold
              text-slate-700
              transition-all
              duration-300
              hover:bg-slate-50
            "
          >
            <FaArrowLeft />

            Dashboard
          </button>
        </div>

        {/* Footer */}

        <div
          className="
            mt-10
            border-t
            border-slate-200
            pt-6
            text-xs
            font-medium
            tracking-[0.25em]
            text-slate-400
          "
        >
          WORKVISTA • PRODUCTIVITY INTELLIGENCE
        </div>
      </div>
    </div>
  );
};

export default NotFound;